import { all, put, takeLatest } from 'redux-saga/effects';
import { TYPES } from './moviesActions';
import { API_SERVER } from '../../config/config';

export function* loadAll({ args }) {
    try {
        const rawResponse = yield fetch(`${API_SERVER.url}/movies`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });
        const movies = yield rawResponse.json();
        yield put({ type: TYPES.LOAD_ALL_SUCCESS, movies });
    } catch (e) {
        yield put({ type: TYPES.LOAD_ALL_ERROR, error: e });
    }
}

export default function* saga() {
    yield all([takeLatest(TYPES.LOAD_ALL, loadAll)]);
}
